/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Born_Next_Fireant_EnchantInputs */

const fr_born_next_fireant_enchant = /** @type {(inputs: Born_Next_Fireant_EnchantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout of the Day`)
};

/**

* @param {Born_Next_Fireant_EnchantInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const born_next_fireant_enchant = /** @type {((inputs?: Born_Next_Fireant_EnchantInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Born_Next_Fireant_EnchantInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_born_next_fireant_enchant(inputs)
});